<template>
  <div class="content if-profile report-tab">
    <div class="md-layout if-profile-body">
      <SPIFReportHeader :headerData="this.headerData"/>

      <div class="md-layout-item p-0">
        <md-card>
          <div class="md-layout md-card if_card">
            <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
              <md-card-header class="md-card-header md-card-header-icon">
                <div class="card_icon">
                  <md-icon>light_mode</md-icon>
                </div>
                About Valuation Multiples
              </md-card-header>
              <div class="md-card-content">
                <div class="extra_space">
                  <p>
                    <b>Search results display up to six values in all:</b> Quartile 1-Median-Quartile 3 multiples for each industry and sale group combination. You are only charged a search credit when an
                                            industry and sales group is selected and the industry multiple values are load on the page. Copy and paste into a file of your choosing to store.<br/><br/>
                                            <b>Business Value Insight Terms</b>: The Bizminer Valuations Value basis is derived from projected company sales; peer group average earnings %; and industry valuation multiples. Median
                                            ranges reflect a range of market conditions and business performance at this revenue scale.<br/><br/>
                                            You should not use Bizminer Valuations in place of a professional valuation or as the basis of any specific business-related or other financial transaction; nor to secure a
                                            business or personal loan.<br/><br/>
                                            <b>Owner Earnings (Cash Flow) Approach:</b> Revenue/Owner Earnings market valuation approach<br/><br/>
                                            <b>Sales Approach:</b> Revenue/Annual Sales market value approach<br/><br/>
                                            <b>Note:</b> Median is the point at which 50% of a sample is above and 50% of the same below the value. Quartile 1 lies at the mid-point between the median and the lowest value; Quartile 3
                                            between the median and the highest value.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <md-card-content class="p-0 negetive_margin">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 tbl-box md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <!-- <div class="card-icon">
                        <i class="md-icon md-icon-font md-theme-default"
                          >receipt</i
                        >
                      </div>-->
                      <h4 class="title m-0">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                        >Sales Group: &#60; $2.5m</div>
                      </h4>
                    </template>

                    <template slot="content">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table v-model="tableInfo" table-header-color="blue">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                              <md-table-cell md-label>
                                <div class="md-table-side-label">{{ item.name }}</div>
                              </md-table-cell>
                              <md-table-cell md-label="Sales Multiples">
                                {{
                                  multiplesA[`Sales${item.id}`]
                                }}
                              </md-table-cell>
                              <md-table-cell md-label="Earnings Multiples">
                                {{
                                  multiplesA[`Earnings${item.id}`]
                                }}
                              </md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </template>
                  </table-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 tbl-box md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <!-- <div class="card-icon">
                      <i class="md-icon md-icon-font md-theme-default"
                        >receipt</i
                      >
                      </div>-->
                      <h4 class="title m-0">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                        >Sales Group: $2.5m - $24.9m</div>
                      </h4>
                    </template>

                    <template slot="content">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table v-model="tableInfo" table-header-color="blue">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                              <md-table-cell md-label>
                                <div class="md-table-side-label">{{ item.name }}</div>
                              </md-table-cell>
                              <md-table-cell md-label="Sales Multiples">
                                {{
                                  multiplesB[`Sales${item.id}`]
                                }}
                              </md-table-cell>
                              <md-table-cell md-label="Earnings Multiples">
                                {{
                                  multiplesB[`Earnings${item.id}`]
                                }}
                              </md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </template>
                  </table-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 tbl-box md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <!-- <div class="card-icon">
                      <i class="md-icon md-icon-font md-theme-default"
                        >receipt</i
                      >
                      </div>-->
                      <h4 class="title m-0">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                        >Sales Group: &#62; $25m</div>
                      </h4>
                    </template>

                    <template slot="content">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table v-model="tableInfo" table-header-color="blue">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                              <md-table-cell md-label>
                                <div class="md-table-side-label">{{ item.name }}</div>
                              </md-table-cell>
                              <md-table-cell md-label="Sales Multiples">
                                {{
                                  multiplesC[`Sales${item.id}`]
                                }}
                              </md-table-cell>
                              <md-table-cell md-label="Earnings Multiples">
                                {{
                                  multiplesC[`Earnings${item.id}`]
                                }}
                              </md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </template>
                  </table-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 tbl-box md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <!-- <div class="card-icon">
                      <i class="md-icon md-icon-font md-theme-default"
                        >receipt</i
                      >
                      </div>-->
                      <h4 class="title m-0">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                        >Sales Group: All</div>
                      </h4>
                    </template>

                    <template slot="content">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table v-model="tableInfo" table-header-color="blue">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                              <md-table-cell md-label>
                                <div class="md-table-side-label">{{ item.name }}</div>
                              </md-table-cell>
                              <md-table-cell md-label="Sales Multiples">
                                {{
                                  multiplesAll[`Sales${item.id}`]
                                }}
                              </md-table-cell>
                              <md-table-cell md-label="Earnings Multiples">
                                {{
                                  multiplesAll[`Earnings${item.id}`]
                                }}
                              </md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </template>
                  </table-card>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>

      
    </div>
  </div>
</template>

<script>
import { TableCard } from '@/components';
import { mapState } from 'vuex';
import SPIFReportHeader from './_partials/SPIFHeader.vue';

export default {
  components: {
    SPIFReportHeader,
    TableCard,

  },
  props: ['headerData'],
  data() {
    return {
      tableInfo: [
        {
          id: 'Low',
          name: 'Q1',
        },
        {
          id: 'Med',
          name: 'Median',
        },
        {
          id: 'High',
          name: 'Q3',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      multiplesA: (state) => {
        return state.user.report.data['multiples_A'] &&
          state.user.report.data['multiples_A'] != ''
          ? state.user.report.data['multiples_A']
          : [];
      },
      multiplesB: (state) => {
        return state.user.report.data['multiples_B'] &&
          state.user.report.data['multiples_B'] != ''
          ? state.user.report.data['multiples_B']
          : [];
      },
      multiplesC: (state) => {
        return state.user.report.data['multiples_C'] &&
          state.user.report.data['multiples_C'] != ''
          ? state.user.report.data['multiples_C']
          : [];
      },
      multiplesAll: (state) => {
        return state.user.report.data['multiples_all'] &&
          state.user.report.data['multiples_all'] != ''
          ? state.user.report.data['multiples_all']
          : [];
      },
    }),
  },
  methods: {},
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}
.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}
</style>
